import { Injectable } from '@angular/core';
import { EntraLoginBody, LoginBody } from '@core/models/api/auth.model';
import { HTTPService } from './http.service';
import { LocalStorageService } from './local-storage.service';
import { AuthToken } from '@core/interface/common/auth-token';
import { AUTH_ENTRA_LOGIN_ENDPOINT, AUTH_GET_SCOPES_ENDPOINT, AUTH_LOGIN_ENDPOINT, AUTH_REFRESH_TOKEN_ENDPOINT, AUTH_CHANGE_PASSWORD_ENDPOINT, AUTH_CHANGE_PASSWORD_ON_FIRST_LOGIN_ENDPOINT } from '@core/constant/endpoints';
import { ChangePasswordParam } from '@core/models/api/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private httpService: HTTPService,
    private localStorageService: LocalStorageService
  ) {}
  login = (body: LoginBody) => {
    return this.httpService.create<AuthToken>({
      resource: AUTH_LOGIN_ENDPOINT,
      body,
    });
  };
  entraLogin = (body: EntraLoginBody) => {
    return this.httpService.create<AuthToken>({
      resource: AUTH_ENTRA_LOGIN_ENDPOINT,
      body,
    });
  };
  getScopes = () => {
    return this.httpService.get<string[]>({
      resource: AUTH_GET_SCOPES_ENDPOINT,
    });
  };
  refreshToken = (refreshToken: string) => {
    return this.httpService.create<AuthToken>({
      resource: AUTH_REFRESH_TOKEN_ENDPOINT,
      body: {refreshToken}

    });
  }
  changePassword = (body: ChangePasswordParam) => {
    return this.httpService.create<{ message: string }>({
      resource: AUTH_CHANGE_PASSWORD_ENDPOINT,
      body,
    });
  }
  changePasswordOnFirstLogin = (body: { Username: string; CurrentPassword: string; NewPassword: string }) => {
    return this.httpService.create<AuthToken>({
      resource: AUTH_CHANGE_PASSWORD_ON_FIRST_LOGIN_ENDPOINT,
      body,
    });
  }
  logout = () => {
    this.localStorageService.clearData();
  };
}
